var _defs, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamviewer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.77384 0 0 1.71427 42.46 39.38)",
    gradientUnits: "userSpaceOnUse",
    y2: -22.851,
    x2: -11.233,
    y1: 4.675,
    x1: -10.767,
    id: 0
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#197cf1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21c9fb",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(1.4 0 0 1.39991 109.94 1027.47)",
    gradientUnits: "userSpaceOnUse",
    y2: 4.445,
    x2: 0,
    y1: 35.14,
    id: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    height: 48,
    width: 48,
    rx: 3.085,
    fill: "url(#0)",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m65.69 1034.21c-11.609 0-21 9.393-21 21 0 11.608 9.391 20.999 21 20.999 11.609 0 21-9.39 21-20.999 0-11.608-9.391-21-21-21m-5.283 14v3.501h10.566v-3.501l5.759 3.501 5.759 3.499-5.759 3.499-5.759 3.501v-4h-10.566v4l-5.759-3.501-5.759-3.499 5.759-3.499 5.759-3.501",
    fill: "url(#1)",
    transform: "translate(-41.692-1031.21)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamviewer);
export default __webpack_public_path__ + "static/media/teamviewer.8d296606.svg";
export { ForwardRef as ReactComponent };